export default {
    title: "Importar pedidos",
    upload_label: "Por favor envie un archivo .csv",
    help_center: "Ver centro de ayuda",
    select_branch: "Por favor seleccione la sucursal",
    one_row_per_product: "El CSV contiene una fila por producto?",
    loading_message: "Enviando datos, esto puede tardar algunos minutos...",
    file_size_error: "El archivo debe tener hasta {0}MB",
    csv_error: "Ocurrio un error al leer el CSV, verifique si el archivo es valido",
    order_id_required: "Selecciona la columna del Id del Pedido para continuar. Es obligatoria e identifica cada pedido.",
    include_time: "Contiene la hora tambien",
    format: "Formato",
    decimal_separator: "Separador Decimal",
    full_name: "Contiene el nombre completo",
    default_prefix: "Codigo de area por defecto",
    products: "Productos",
    brand: "Marca",
    category: "Categoria",
    price: "Precio",
    cost: "Costo",
    summary: {
        new_clients: "Nuevos clientes",
        new_orders: "Nuevos pedidos",
        updated_status: "Actualizaciones de estado",
        already_imported: "Pedidos que ya existian y no fueron importados",
        failed_rows: "Filas que fallaron:",
    },
    download_csv: "Descargar CSV",
    cancel: "Cancelar",
    next: "Siguiente",
    back: "Volver",
    import: "Importar",
    close: "Cerrar",
    queued_message: "¡Importación enviada! Se procesará en segundo plano.",
    queued_link: "Seguir en el historial de importaciones",
    open_button: "Importar pedidos",
    columns: {
        external_id: "Id del Pedido",
        client_external_id: "Id del cliente",
        date: "Fecha",
        time: "Hora",
        value: "Valor",
        first_name: "Nombre",
        last_name: "Apellido",
        whatsapp: "Telefono",
        email: "E-mail",
        birthdate: "Fecha de Nacimiento",
        external_status: "Estado del Pedido",
        status: "Estado de Kevi",
        product_external_id: "Id del Producto",
        product_name: "Nombre del Producto",
        category: "Categoria del Producto",
        brand: "Marca del Producto",
        price: "Precio del Producto",
        cost: "Costo del Producto",
        quantity: "Cantidad del Producto",
    },
};
